module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/rowhouse-ee48cf0acebbfe4243b15a6f7ef05412.png";